<template>
  <div>
    <vue-headful :title="meta_title" description="Description goes here" />
    <div class="teacher-profile-section base-type-layout">
      <!-- BREADCRUMB -->
      <BreadCrumb
        :item_one="current_class_name"
        item_three="Teacher"
        item_two="Members"
        :item_two_link="route_link"
        route_name="TeacherProfile"
        :route_list="teachers_list"
        :route_list_length="Number(route_list_length)"
      ></BreadCrumb>

      <!-- TEACHER PROFILE CONTAINER -->
      <div class="container teacher-container">
        <div class="row">
          <!-- PROFILE PHOTO -->
          <div class="col-12 col-md-3 d-none d-md-block side-photo mx-auto">
            <!-- AVATAR -->
            <div class="avatar avatar_big avatar-square brand_inverse_light_bg">
              <img
                v-lazy="teacher_image"
                :alt="teacher_name"
                class="avatar-img"
                v-if="teacher_image"
              />
              <div
                class="avatar-text white-text font-weight-500 font-50"
                :class="setAvatarBg"
                v-else
              >
                {{ getInitial }}
              </div>
            </div>

            <!-- SEND MESSAGE BUTTON -->
            <!-- <button class="btn btn-md btn-inverse" @click="toggleMessageModal">
              <span class="icon-chat mr-2 font-16"></span> Send a Message
            </button>-->
          </div>

          <!-- PROFILE DETAILS -->
          <div class="col-12 col-md-9">
            <!-- ABOUT ME COMPONENT -->
            <AboutMeSection
              :teacher_img="teacher_image"
              :teacher_name="teacher_name"
              :teacher_subjects="teacher_subjects"
              :class_count="teacher_classes.length"
              :homework_count="teacher_homeworks.length"
              :about_me_text="teacher_about_me"
              :teacher_phone="teacher_phone"
              :teacher_email="teacher_email"
              :teacher_address="teacher_address"
              @toggleMessage="toggleMessageModal"
            ></AboutMeSection>
            <!-- ABOUT ME COMPONENT -->

            <!-- CLASS ASSIGNED COMPONENT -->
            <ClassAssigned
              :classes="teacher_classes"
              @assign-teacher-subject="toggleSubjectModal($event)"
              @remove-teacher-subject="toggleSubjectModal($event)"
              @assign-to-class="toggleAssignClassModal"
            ></ClassAssigned>
            <!-- CLASS ASSIGNED COMPONENT -->

            <!-- SCHEDULE COMPONENT -->
            <Schedule :teacher_id="teacher_id"></Schedule>
            <!-- SCHEDULE COMPONENT -->

            <!-- HOMEWORK COMPONENT -->
            <Homework
              :teacher_name="teacher_name"
              :homeworks="teacher_homeworks"
            ></Homework>
            <!-- HOMEWORK COMPONENT -->
          </div>
        </div>
      </div>
    </div>

    <SectionLoader
      :loader_text="loader_text"
      v-if="teacher_count === 0"
    ></SectionLoader>

    <!-- MODAL -->
    <ResponseDialog
      v-if="response_dialog"
      :alert_msg="alert_card_msg"
      :alert_type="alert_card_type"
      @closeAlert="toggleResponseDialog"
    ></ResponseDialog>

    <AssignClassModal
      v-if="assign_class_modal"
      :teacher_id="teacher_id"
      @refreshPage="fetchTeacherProfile"
      @closeTriggered="toggleAssignClassModal"
    ></AssignClassModal>

    <AssignSubjectModal
      v-if="assign_subject_modal"
      :teacher_data="teacher_data_info"
      @showAlertCard="popUpAlert($event)"
      @closeTriggered="toggleSubjectModal"
    ></AssignSubjectModal>

    <NewMessageModal
      v-if="message_modal"
      @closeTriggered="toggleMessageModal"
    ></NewMessageModal>
    <!-- MODAL -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { setInitial } from "@/scripts/utilities";
import { setProfileBg } from "@/scripts/profile-colors";
import BreadCrumb from "@/components/globalComps/BreadCrumb";
import SectionLoader from "@/components/globalComps/SectionLoader";
import AboutMeSection from "@/components/profileComps/teacherprofile/AboutMeSection";
import ClassAssigned from "@/components/profileComps/teacherprofile/ClassAssigned";
import Schedule from "@/components/profileComps/teacherprofile/Schedule";
import Homework from "@/components/profileComps/teacherprofile/Homework";

export default {
  name: "TeacherProfile",

  components: {
    BreadCrumb,
    SectionLoader,
    AboutMeSection,
    ClassAssigned,
    Schedule,
    Homework,
    NewMessageModal: () =>
      import(
        /* webpackChunkName: "NewMessageModal" */ "@/components/modalComps/messageModals/NewMessageModal"
      ),
    AssignSubjectModal: () =>
      import(
        /* webpackChunkName: "teachermodal" */ "@/components/modalComps/schoolModals/AssignSubjectModal"
      ),
    AssignClassModal: () =>
      import(
        /* webpackChunkName: "teachermodal" */ "@/components/modalComps/schoolModals/AssignClassModal"
      ),
    ResponseDialog: () =>
      import(
        /* webpackChunkName: "ResponseDialog" */ "@/components/globalComps/ResponseDialog"
      ),
  },

  computed: {
    // GET CURRENT CLASS IS FOR SCHOOL, WHILE GET CURRENT CLASS ID IS FOR TEACHER
    ...mapGetters(["classList", "getCurrentClass", "getCurrentClassID"]),

    meta_title() {
      return `${this.teacher_name.toUpperCase()} | Teacher Profile`;
    },

    setAvatarBg() {
      return setProfileBg(this.teacher_name);
    },

    getInitial() {
      return setInitial(this.teacher_name);
    },

    capitalize(str) {
      return str.replace(/\b\w/g, (l) => l.toUpperCase());
    },
  },

  data() {
    return {
      loader_text: "Loading Teacher Info",
      message_modal: false,
      assign_class_modal: false,
      assign_subject_modal: false,

      teacher_name: "No Teacher",
      teacher_id: null,
      teacher_image: null,
      teacher_about_me: null,
      teacher_phone: null,
      teacher_email: null,
      teacher_address: null,
      teacher_subjects: [],
      teacher_classes: [],
      teacher_homeworks: [],
      teacher_count: 0,

      account_type: null,
      current_class_name: null,
      route_link: null,
      route_list_length: 0,
      teachers_list: [],
      teacher_data_info: {},

      alert_card_msg: "",
      alert_card_type: "",
      response_dialog: false,
    };
  },

  created() {
    this.getAccountType();
    if (this.$route.query.id)
      this.teacher_id = Number([...this.$route.query.id].slice(11).join(""));
    else this.$router.push({ name: this.route_link });
  },

  mounted() {
    this.getClassName();
    this.setupBreadcrumb();
    this.fetchTeacherProfile();
  },

  methods: {
    ...mapActions(["getTeacherProfile", "getTeachersInClass"]),

    toggleAssignClassModal() {
      this.assign_class_modal = !this.assign_class_modal;
    },

    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];
      if (this.account_type === "school")
        this.route_link = "ClassMembersTeachers";
      else if (this.account_type === "teacher")
        this.route_link = "TeacherMembers";
    },

    toggleResponseDialog() {
      this.response_dialog = !this.response_dialog;
    },

    popUpAlert($event) {
      this.alert_card_msg = $event.msg;
      this.alert_card_type = $event.type;
      this.toggleResponseDialog();
      this.fetchTeacherProfile();
    },

    toggleSubjectModal(data) {
      this.assign_subject_modal = !this.assign_subject_modal;

      this.assign_subject_modal
        ? (this.teacher_data_info = {
            teacher_id: Number(this.teacher_id),
            class_id: data.class_id || 0,
            modal_type: data.type || "assign",
            subjects: data.subjects || [],
          })
        : null;
    },

    toggleMessageModal() {
      this.message_modal = !this.message_modal;
    },

    fetchTeacherProfile() {
      this.getTeacherProfile(this.teacher_id)
        .then((response) => {
          console.log("loaded");
          console.log(response);
          if (response.code === 200 && response.data !== null) {
            let data = response.data;
            this.teacher_name = `${data.firstname} ${data.lastname}`;
            this.teacher_image = data.image;
            this.teacher_phone = data.phone;
            this.teacher_email = data.email;
            this.teacher_about_me = data.profile.about;
            this.teacher_address = data.profile.address;
            this.teacher_subjects = data.subjects;
            this.teacher_classes = data.classes;
            this.teacher_homeworks = data.homework;
            this.teacher_count += 1;
          } else {
            setTimeout(() => {
              this.loader_text = "Invalid Teacher Id. Redirecting";
            }, 1500);

            setTimeout(() => {
              this.$router.push({ name: this.route_link });
            }, 2500);
          }
        })
        .catch((err) => console.log(err));
    },

    async getClassName() {
      // SCHOOL ACCOUNT
      if (this.account_type === "school") {
        let query = await this.$store.dispatch(
          "getSingleClass",
          this.getCurrentClass
        );
        this.current_class_name = query.data.class_name;
      }
      // TEACHER ACCOUNT
      else if (this.account_type === "teacher") {
        console.log("Add teacher endpoint");
      }
    },

    setupBreadcrumb() {
      // SCHOOL ACCOUNT
      if (this.account_type === "school") {
        console.log("current class", this.getCurrentClass);
        if (this.getCurrentClass) {
          this.getTeachersInClass(this.getCurrentClass)
            .then((response) => {
              response.data.map((teacher) => {
                this.teachers_list.push(teacher.id);
              });
              this.route_list_length = this.teachers_list.length;
            })
            .catch((err) => console.log(err));
        } else {
          this.$router.push({ name: this.route_link });
        }
      }

      // TEACHER ACCOUNT
      else if (this.account_type === "teacher") {
        if (this.getCurrentClassID) {
          this.getAllStudents(this.account_type, this.getCurrentClassID)
            .then((response) => {
              response.data.map((teacher) => {
                this.teachers_list.push(teacher.id);
              });
              this.route_list_length = this.teachers_list.length;
            })
            .catch((err) => console.log(err));
        } else {
          this.$router.push({ name: this.route_link });
        }
      }
    },
  },
};
</script>

<style></style>
